// Shopify Custom Metafields Add-on
// This script adds age and other custom metafields to your Shopify store products
// Fixed version - corrected syntax errors

(function() {
  // Configuration - customize these fields as needed
  const METAFIELDS_CONFIG = [
    {
      name: "Age recommandé",
      namespace: "product",
      key: "age_range",
      type: "single_line_text",
      description: "Âge recommandé pour ce produit (ex: 0-3 ans)"
    },
    {
      name: "Composition",
      namespace: "product",
      key: "composition",
      type: "multi_line_text",
      description: "Matériaux et composition du produit"
    },
    {
      name: "Entretien",
      namespace: "product",
      key: "care_instructions",
      type: "multi_line_text",
      description: "Instructions d'entretien du produit"
    },
    {
      name: "Dimensions",
      namespace: "product",
      key: "dimensions",
      type: "single_line_text",
      description: "Dimensions du produit (ex: 20 x 15 x 10 cm)"
    }
  ];

  // CSS styles for the metafields display
  const STYLES = `
    .custom-metafields {
      margin-top: 20px;
      margin-bottom: 20px;
      border-top: 1px solid #e8e8e8;
      padding-top: 15px;
    }
    
    .custom-metafields h3 {
      font-size: 16px;
      margin-bottom: 12px;
    }
    
    .metafield-item {
      display: flex;
      margin-bottom: 8px;
    }
    
    .metafield-label {
      font-weight: bold;
      min-width: 120px;
      margin-right: 10px;
    }
    
    .metafield-value {
      flex: 1;
    }
    
    @media (max-width: 768px) {
      .metafield-item {
        flex-direction: column;
      }
      
      .metafield-label {
        margin-bottom: 4px;
      }
    }
  `;

  // Add styles to the document
  function addStyles() {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = STYLES;
    document.head.appendChild(styleElement);
  }

  // Display metafields on product page
  function displayMetafields() {
    // Only run on product pages
    if (!window.location.pathname.includes('/products/')) {
      return;
    }

    // Try different ways to access product data
    let product = null;
    
    // Method 1: Modern Shopify stores
    if (window.meta && window.meta.product) {
      product = window.meta.product;
    } 
    // Method 2: Older Shopify stores
    else if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      product = window.ShopifyAnalytics.meta.product;
    }
    // Method 3: Look for JSON in the page
    else {
      try {
        const jsonElement = document.querySelector('script[type="application/json"][data-product-json]');
        if (jsonElement) {
          product = JSON.parse(jsonElement.textContent);
        }
      } catch (e) {
        console.error('Failed to parse product JSON', e);
      }
    }
    
    // If we couldn't find product data, try again later
    if (!product) {
      console.log('Product data not found, retrying in 500ms');
      setTimeout(displayMetafields, 500);
      return;
    }
    
    // Find a suitable container to append our metafields
    const container = document.querySelector('.product__description') || 
                     document.querySelector('.product-single__description') ||
                     document.querySelector('.product-description') ||
                     document.querySelector('.product-details') ||
                     document.querySelector('.description');
    
    if (!container) {
      console.error('Could not find product description container');
      return;
    }

    // Create metafields section
    const metafieldsSection = document.createElement('div');
    metafieldsSection.className = 'custom-metafields';
    metafieldsSection.innerHTML = '<h3>Caractéristiques du produit</h3>';

    // Check if product has any of our custom metafields
    let hasMetafields = false;
    
    METAFIELDS_CONFIG.forEach(metafield => {
      // Try different methods to access metafields
      let metafieldValue = null;
      
      // Method 1: Direct access
      if (product.metafields && product.metafields[metafield.namespace] && 
          product.metafields[metafield.namespace][metafield.key]) {
        metafieldValue = product.metafields[metafield.namespace][metafield.key];
      }
      // Method 2: Combined namespace_key
      else if (product[`${metafield.namespace}_${metafield.key}`]) {
        metafieldValue = product[`${metafield.namespace}_${metafield.key}`];
      }
      
      if (metafieldValue) {
        hasMetafields = true;
        
        const metafieldItem = document.createElement('div');
        metafieldItem.className = 'metafield-item';
        
        metafieldItem.innerHTML = `
          <div class="metafield-label">${metafield.name}:</div>
          <div class="metafield-value">${metafieldValue}</div>
        `;
        
        metafieldsSection.appendChild(metafieldItem);
      }
    });

    // Only append the section if we found metafields
    if (hasMetafields) {
      container.appendChild(metafieldsSection);
    } else {
      console.log('No metafields found for this product');
    }
  }

  // Initialize the add-on
  function init() {
    addStyles();
    
    // Run displayMetafields after a short delay to ensure DOM and product data are ready
    setTimeout(displayMetafields, 500);
    
    // Handle page changes (for themes with Ajax navigation)
    document.addEventListener('page:loaded', displayMetafields);
    document.addEventListener('shopify:section:load', displayMetafields);
  }

  // Run initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();